if (!customElements.get('stash-subscription-widget')) {
  class StashSubscriptionWidget extends HTMLElement {
    constructor() {
      super();

      this.oneTimeRadio = null;
      this.subscriptionRadio = null;
      this.sellingPlanInput = null;
      this.sellingPlanContainer = null;
      this.sellingPlanButtons = [];

      this.activeSellingPlanId = null;
    }

    connectedCallback() {

      this.initializeElements();

      this.initializeState();

      this.attachEventListeners();
    }

    initializeElements() {

      this.oneTimeRadio =
        this.querySelector('.stash-one-time-group-input');

      this.subscriptionRadio =
        this.querySelector('.stash-subscription-group-input');

      this.sellingPlanInput =
        this.querySelector('[data-selling-plan-input]');

      this.sellingPlanContainer =
        this.querySelector('.selling-plan-buttons');

      this.sellingPlanButtons =
        Array.from(
          this.querySelectorAll('.selling-plan-button')
        );
    }

    initializeState() {

      if (this.subscriptionRadio?.checked) {

        this.enableSubscription();

      } else {

        this.enableOneTime();

      }
    }

    attachEventListeners() {

      this.oneTimeRadio.addEventListener(
        'change',
        () => this.enableOneTime()
      );

      this.subscriptionRadio?.addEventListener(
        'change',
        () => this.enableSubscription()
      );

      this.sellingPlanButtons.forEach(button => {

        button.addEventListener(
          'click',
          () => this.selectSellingPlan(button)
        );

      });
    }

    enableOneTime() {

      this.hideSellingPlans();

      this.sellingPlanInput.value = "";

      this.activeSellingPlanId = null;

      this.dispatchChangeEvent();
    }

    enableSubscription() {

      this.showSellingPlans();

      if (!this.activeSellingPlanId &&
          this.sellingPlanButtons.length > 0) {

        this.selectSellingPlan(
          this.sellingPlanButtons[0]
        );

      } else {

        this.dispatchChangeEvent();

      }
    }

    showSellingPlans() {

      this.sellingPlanContainer.style.display = "flex";

      this.sellingPlanButtons.forEach(button => {

        button.style.display = "block";

      });
    }

    hideSellingPlans() {

      this.sellingPlanContainer.style.display = "none";

      this.sellingPlanButtons.forEach(button => {

        button.style.display = "none";

      });
    }

    selectSellingPlan(button) {

      this.sellingPlanButtons.forEach(btn => {
        btn.classList.remove('active');
      });

      button.classList.add('active');

      const sellingPlanId =
        button.dataset.sellingPlanId;

      this.activeSellingPlanId =
        sellingPlanId;

      this.sellingPlanInput.value =
        sellingPlanId;

      this.dispatchChangeEvent();
    }

    dispatchChangeEvent() {

      this.dispatchEvent(
        new CustomEvent(
          "selling-plan-changed",
          {
            bubbles: true,
            composed: true,
            detail: {
              sellingPlanId:
                this.activeSellingPlanId
            }
          }
        )
      );
    }

  }
  customElements.define(
    'stash-subscription-widget',
    StashSubscriptionWidget
  );
}

